import { configFile } from "@/config";
import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";
import { Flex, Link as ChakraLink, Text } from "@chakra-ui/react";
import useTranslation from "next-translate/useTranslation";
import Link from "next/link";

interface Props {
    prevHref?: string,
    isPrevDisabled?: boolean,
    page?: number,
    setPage: React.Dispatch<React.SetStateAction<number | undefined>>,
    handleClick?: any,
    pageCount?: number,
    isNextDisabled?: boolean,
    slug?: string
}

export default function Pagination({
    slug,
    prevHref,
    isPrevDisabled,
    page,
    setPage,
    handleClick,
    pageCount,
    isNextDisabled
}: Props) {
    const { t } = useTranslation("common");


    return (
        <Flex
            w={'100%'}
            padding="12px"
            bgColor="#fff"
            columnGap={{ base: "16px", md: "32px" }}
            border="1px solid #E2E8F0"
            borderRadius="6px"
            alignItems="center"
            width="fit-content"
            margin="0 auto"
            mb="80px"
        >
            <ChakraLink prefetch={false}
                as={Link}
                href={prevHref}
                className={isPrevDisabled ? "disabled" : ""}
                onClick={(e) => [
                    e.preventDefault(),
                    setPage(page! - 1),
                    handleClick,
                ]}
                width={{ base: "90px", md: "150px" }}
                display="flex"
                alignItems="center"
                bgColor={configFile.primaryAccentColor}
                height="40px"
                justifyContent="center"
                borderRadius="6px"
                lineHeight="1"
                fontWeight="600"
                fontSize={{ base: "13px", md: "16px" }}
                color="#fff"
                border="1px solid transparent"
                _hover={{
                    color: "gray.800",
                    bgColor: "#fff",
                    borderColor: "#E2E8F0",
                }}
                _disabled={{ bgColor: "#fff", borderColor: "#E2E8F0" }}
            >
                <ChevronLeftIcon />
                {t("article.previous")}
            </ChakraLink>
            <Text
                fontSize={{ base: "13px", md: "16px" }}
                color="gray.500"
                fontWeight="400"
            >
                {t("article.page")} {page} {t("article.of")} {pageCount}
            </Text>
            <ChakraLink prefetch={false}
                as={Link}
                href={isNextDisabled ? "" : `/${slug}?page=${page! + 1}`}
                className={isNextDisabled ? "disabled" : ""}
                onClick={(e) => [
                    e.preventDefault(),
                    setPage(page! + 1),
                    handleClick,
                ]}
                width={{ base: "90px", md: "150px" }}
                display="flex"
                justifyContent="center"
                borderRadius="6px"
                height="40px"
                alignItems="center"
                bgColor={configFile.primaryAccentColor}
                lineHeight="1"
                fontWeight="600"
                fontSize={{ base: "13px", md: "16px" }}
                border="1px solid transparent"
                color="#fff"
                _hover={{
                    color: "gray.800",
                    bgColor: "#fff",
                    borderColor: "#E2E8F0",
                }}
                _disabled={{
                    color: "gray.800",
                    bgColor: "#fff",
                    borderColor: "#E2E8F0",
                }}
            >
                {t("article.next")} <ChevronRightIcon />
            </ChakraLink>
        </Flex>

    );
}